import { useEffect, useState } from "react";
import { VideoEmbed } from "./VideoEmbed";

const VIDEOS = [
  { id: "IYafLg1la40", title: "Agent testimonial - Kristan Cole Network" },
  { id: "BLktI45ouho", title: "Why agents join KCN" },
  { id: "vjBCV6J3Wxs", title: "Inside the Kristan Cole Network" },
];

export function ReviewsWidget() {
  const [start, setStart] = useState(0);
  const len = VIDEOS.length;

  useEffect(() => {
    const id = setInterval(() => setStart((s) => (s + 1) % len), 7000);
    return () => clearInterval(id);
  }, [len]);

  const visible = [VIDEOS[start % len], VIDEOS[(start + 1) % len]];

  const next = () => setStart((s) => (s + 1) % len);
  const prev = () => setStart((s) => (s - 1 + len) % len);

  return (
    <div className="w-full">
      <div className="grid gap-6 md:grid-cols-2">
        {visible.map((v) => (
          <div
            key={v.id}
            className="relative aspect-video w-full overflow-hidden rounded-sm border border-white/10 bg-black animate-fade-in"
          >
            <VideoEmbed id={v.id} title={v.title} />
          </div>
        ))}
      </div>


      <div className="mt-6 flex items-center justify-between">
        <div className="flex gap-2">
          {VIDEOS.map((v, i) => (
            <button
              key={v.id}
              onClick={() => setStart(i)}
              aria-label={`Show video ${i + 1}`}
              className={`h-1.5 w-8 rounded-full transition-colors ${
                i === start ? "bg-primary" : "bg-white/20 hover:bg-white/40"
              }`}
            />
          ))}
        </div>
        <div className="flex gap-2">
          <button
            onClick={prev}
            className="rounded-sm border border-white/15 px-3 py-1.5 text-xs uppercase tracking-wider text-white/70 transition hover:border-white/40 hover:text-white"
          >
            Prev
          </button>
          <button
            onClick={next}
            className="rounded-sm border border-white/15 px-3 py-1.5 text-xs uppercase tracking-wider text-white/70 transition hover:border-white/40 hover:text-white"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
